/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminCourseStatsBreakdownResponse } from '../models';
// @ts-ignore
import type { AdminCourseStatsCourseDetailResponse } from '../models';
// @ts-ignore
import type { AdminCourseStatsCoursesResponse } from '../models';
// @ts-ignore
import type { AdminCourseStatsForgeResponse } from '../models';
// @ts-ignore
import type { AdminCourseStatsJobCoursesResponse } from '../models';
// @ts-ignore
import type { AdminCourseStatsLearnerResponse } from '../models';
// @ts-ignore
import type { AdminCourseStatsLearnersResponse } from '../models';
// @ts-ignore
import type { AdminCourseStatsOverviewResponse } from '../models';
// @ts-ignore
import type { AdminCourseStatsPathsResponse } from '../models';
// @ts-ignore
import type { AdminCourseStatsTimeseriesResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
/**
 * CourseStatsApiApi - axios parameter creator
 */
export const CourseStatsApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsBreakdown: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course-statistics/breakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsCourse: async (courseId: string, endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('courseStatsApiGetAdminCourseStatsCourse', 'courseId', courseId)
            const localVarPath = `/admin/course-statistics/courses/{course_id}`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {CourseStatsApiGetAdminCourseStatsCoursesKindEnum} [kind] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {CourseStatsApiGetAdminCourseStatsCoursesSortByEnum} [sortBy] 
         * @param {CourseStatsApiGetAdminCourseStatsCoursesSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsCourses: async (endDate?: string | null, excludeInternal?: boolean, kind?: CourseStatsApiGetAdminCourseStatsCoursesKindEnum, page?: number, pageSize?: number, search?: string | null, sortBy?: CourseStatsApiGetAdminCourseStatsCoursesSortByEnum, sortOrder?: CourseStatsApiGetAdminCourseStatsCoursesSortOrderEnum, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course-statistics/courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsForge: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course-statistics/forge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsJobCourses: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course-statistics/job-courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsLearner: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('courseStatsApiGetAdminCourseStatsLearner', 'userId', userId)
            const localVarPath = `/admin/course-statistics/learners/{user_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CourseStatsApiGetAdminCourseStatsLearnersActivityEnum} [activity] 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {CourseStatsApiGetAdminCourseStatsLearnersSortByEnum} [sortBy] 
         * @param {CourseStatsApiGetAdminCourseStatsLearnersSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsLearners: async (activity?: CourseStatsApiGetAdminCourseStatsLearnersActivityEnum, endDate?: string | null, excludeInternal?: boolean, page?: number, pageSize?: number, search?: string | null, sortBy?: CourseStatsApiGetAdminCourseStatsLearnersSortByEnum, sortOrder?: CourseStatsApiGetAdminCourseStatsLearnersSortOrderEnum, startDate?: string | null, userId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course-statistics/learners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (activity !== undefined) {
                localVarQueryParameter['activity'] = activity;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Course headline numbers for a window, against the window before it.
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsOverview: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course-statistics/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsPaths: async (endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course-statistics/paths`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {CourseStatsApiGetAdminCourseStatsTimeseriesGranularityEnum} [granularity] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsTimeseries: async (endDate?: string | null, excludeInternal?: boolean, granularity?: CourseStatsApiGetAdminCourseStatsTimeseriesGranularityEnum, startDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course-statistics/timeseries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (excludeInternal !== undefined) {
                localVarQueryParameter['exclude_internal'] = excludeInternal;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CourseStatsApiApi - functional programming interface
 */
export const CourseStatsApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CourseStatsApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseStatsApiGetAdminCourseStatsBreakdown(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCourseStatsBreakdownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseStatsApiGetAdminCourseStatsBreakdown(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseStatsApiApi.courseStatsApiGetAdminCourseStatsBreakdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseStatsApiGetAdminCourseStatsCourse(courseId: string, endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCourseStatsCourseDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseStatsApiGetAdminCourseStatsCourse(courseId, endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseStatsApiApi.courseStatsApiGetAdminCourseStatsCourse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {CourseStatsApiGetAdminCourseStatsCoursesKindEnum} [kind] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {CourseStatsApiGetAdminCourseStatsCoursesSortByEnum} [sortBy] 
         * @param {CourseStatsApiGetAdminCourseStatsCoursesSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseStatsApiGetAdminCourseStatsCourses(endDate?: string | null, excludeInternal?: boolean, kind?: CourseStatsApiGetAdminCourseStatsCoursesKindEnum, page?: number, pageSize?: number, search?: string | null, sortBy?: CourseStatsApiGetAdminCourseStatsCoursesSortByEnum, sortOrder?: CourseStatsApiGetAdminCourseStatsCoursesSortOrderEnum, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCourseStatsCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseStatsApiGetAdminCourseStatsCourses(endDate, excludeInternal, kind, page, pageSize, search, sortBy, sortOrder, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseStatsApiApi.courseStatsApiGetAdminCourseStatsCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseStatsApiGetAdminCourseStatsForge(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCourseStatsForgeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseStatsApiGetAdminCourseStatsForge(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseStatsApiApi.courseStatsApiGetAdminCourseStatsForge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseStatsApiGetAdminCourseStatsJobCourses(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCourseStatsJobCoursesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseStatsApiGetAdminCourseStatsJobCourses(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseStatsApiApi.courseStatsApiGetAdminCourseStatsJobCourses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseStatsApiGetAdminCourseStatsLearner(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCourseStatsLearnerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseStatsApiGetAdminCourseStatsLearner(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseStatsApiApi.courseStatsApiGetAdminCourseStatsLearner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CourseStatsApiGetAdminCourseStatsLearnersActivityEnum} [activity] 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {CourseStatsApiGetAdminCourseStatsLearnersSortByEnum} [sortBy] 
         * @param {CourseStatsApiGetAdminCourseStatsLearnersSortOrderEnum} [sortOrder] 
         * @param {string | null} [startDate] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseStatsApiGetAdminCourseStatsLearners(activity?: CourseStatsApiGetAdminCourseStatsLearnersActivityEnum, endDate?: string | null, excludeInternal?: boolean, page?: number, pageSize?: number, search?: string | null, sortBy?: CourseStatsApiGetAdminCourseStatsLearnersSortByEnum, sortOrder?: CourseStatsApiGetAdminCourseStatsLearnersSortOrderEnum, startDate?: string | null, userId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCourseStatsLearnersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseStatsApiGetAdminCourseStatsLearners(activity, endDate, excludeInternal, page, pageSize, search, sortBy, sortOrder, startDate, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseStatsApiApi.courseStatsApiGetAdminCourseStatsLearners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Course headline numbers for a window, against the window before it.
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseStatsApiGetAdminCourseStatsOverview(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCourseStatsOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseStatsApiGetAdminCourseStatsOverview(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseStatsApiApi.courseStatsApiGetAdminCourseStatsOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseStatsApiGetAdminCourseStatsPaths(endDate?: string | null, excludeInternal?: boolean, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCourseStatsPathsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseStatsApiGetAdminCourseStatsPaths(endDate, excludeInternal, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseStatsApiApi.courseStatsApiGetAdminCourseStatsPaths']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [endDate] 
         * @param {boolean} [excludeInternal] 
         * @param {CourseStatsApiGetAdminCourseStatsTimeseriesGranularityEnum} [granularity] 
         * @param {string | null} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseStatsApiGetAdminCourseStatsTimeseries(endDate?: string | null, excludeInternal?: boolean, granularity?: CourseStatsApiGetAdminCourseStatsTimeseriesGranularityEnum, startDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCourseStatsTimeseriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseStatsApiGetAdminCourseStatsTimeseries(endDate, excludeInternal, granularity, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseStatsApiApi.courseStatsApiGetAdminCourseStatsTimeseries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CourseStatsApiApi - factory interface
 */
export const CourseStatsApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CourseStatsApiApiFp(configuration)
    return {
        /**
         * 
         * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsBreakdownRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsBreakdown(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsBreakdownRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminCourseStatsBreakdownResponse> {
            return localVarFp.courseStatsApiGetAdminCourseStatsBreakdown(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsCourseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsCourse(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsCourseRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCourseStatsCourseDetailResponse> {
            return localVarFp.courseStatsApiGetAdminCourseStatsCourse(requestParameters.courseId, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsCoursesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsCourses(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsCoursesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminCourseStatsCoursesResponse> {
            return localVarFp.courseStatsApiGetAdminCourseStatsCourses(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.kind, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsForgeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsForge(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsForgeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminCourseStatsForgeResponse> {
            return localVarFp.courseStatsApiGetAdminCourseStatsForge(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsJobCoursesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsJobCourses(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsJobCoursesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminCourseStatsJobCoursesResponse> {
            return localVarFp.courseStatsApiGetAdminCourseStatsJobCourses(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsLearnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsLearner(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsLearnerRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCourseStatsLearnerResponse> {
            return localVarFp.courseStatsApiGetAdminCourseStatsLearner(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsLearnersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsLearners(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsLearnersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminCourseStatsLearnersResponse> {
            return localVarFp.courseStatsApiGetAdminCourseStatsLearners(requestParameters.activity, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Course headline numbers for a window, against the window before it.
         * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsOverview(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsOverviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminCourseStatsOverviewResponse> {
            return localVarFp.courseStatsApiGetAdminCourseStatsOverview(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsPathsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsPaths(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsPathsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminCourseStatsPathsResponse> {
            return localVarFp.courseStatsApiGetAdminCourseStatsPaths(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsTimeseriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseStatsApiGetAdminCourseStatsTimeseries(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsTimeseriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminCourseStatsTimeseriesResponse> {
            return localVarFp.courseStatsApiGetAdminCourseStatsTimeseries(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.granularity, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for courseStatsApiGetAdminCourseStatsBreakdown operation in CourseStatsApiApi.
 */
export interface CourseStatsApiApiCourseStatsApiGetAdminCourseStatsBreakdownRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for courseStatsApiGetAdminCourseStatsCourse operation in CourseStatsApiApi.
 */
export interface CourseStatsApiApiCourseStatsApiGetAdminCourseStatsCourseRequest {
    readonly courseId: string

    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for courseStatsApiGetAdminCourseStatsCourses operation in CourseStatsApiApi.
 */
export interface CourseStatsApiApiCourseStatsApiGetAdminCourseStatsCoursesRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly kind?: CourseStatsApiGetAdminCourseStatsCoursesKindEnum

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null

    readonly sortBy?: CourseStatsApiGetAdminCourseStatsCoursesSortByEnum

    readonly sortOrder?: CourseStatsApiGetAdminCourseStatsCoursesSortOrderEnum

    readonly startDate?: string | null
}

/**
 * Request parameters for courseStatsApiGetAdminCourseStatsForge operation in CourseStatsApiApi.
 */
export interface CourseStatsApiApiCourseStatsApiGetAdminCourseStatsForgeRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for courseStatsApiGetAdminCourseStatsJobCourses operation in CourseStatsApiApi.
 */
export interface CourseStatsApiApiCourseStatsApiGetAdminCourseStatsJobCoursesRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for courseStatsApiGetAdminCourseStatsLearner operation in CourseStatsApiApi.
 */
export interface CourseStatsApiApiCourseStatsApiGetAdminCourseStatsLearnerRequest {
    readonly userId: string
}

/**
 * Request parameters for courseStatsApiGetAdminCourseStatsLearners operation in CourseStatsApiApi.
 */
export interface CourseStatsApiApiCourseStatsApiGetAdminCourseStatsLearnersRequest {
    readonly activity?: CourseStatsApiGetAdminCourseStatsLearnersActivityEnum

    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null

    readonly sortBy?: CourseStatsApiGetAdminCourseStatsLearnersSortByEnum

    readonly sortOrder?: CourseStatsApiGetAdminCourseStatsLearnersSortOrderEnum

    readonly startDate?: string | null

    readonly userId?: string | null
}

/**
 * Request parameters for courseStatsApiGetAdminCourseStatsOverview operation in CourseStatsApiApi.
 */
export interface CourseStatsApiApiCourseStatsApiGetAdminCourseStatsOverviewRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for courseStatsApiGetAdminCourseStatsPaths operation in CourseStatsApiApi.
 */
export interface CourseStatsApiApiCourseStatsApiGetAdminCourseStatsPathsRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly startDate?: string | null
}

/**
 * Request parameters for courseStatsApiGetAdminCourseStatsTimeseries operation in CourseStatsApiApi.
 */
export interface CourseStatsApiApiCourseStatsApiGetAdminCourseStatsTimeseriesRequest {
    readonly endDate?: string | null

    readonly excludeInternal?: boolean

    readonly granularity?: CourseStatsApiGetAdminCourseStatsTimeseriesGranularityEnum

    readonly startDate?: string | null
}

/**
 * CourseStatsApiApi - object-oriented interface
 */
export class CourseStatsApiApi extends BaseAPI {
    /**
     * 
     * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsBreakdownRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseStatsApiGetAdminCourseStatsBreakdown(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsBreakdownRequest = {}, options?: RawAxiosRequestConfig) {
        return CourseStatsApiApiFp(this.configuration).courseStatsApiGetAdminCourseStatsBreakdown(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsCourseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseStatsApiGetAdminCourseStatsCourse(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsCourseRequest, options?: RawAxiosRequestConfig) {
        return CourseStatsApiApiFp(this.configuration).courseStatsApiGetAdminCourseStatsCourse(requestParameters.courseId, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsCoursesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseStatsApiGetAdminCourseStatsCourses(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsCoursesRequest = {}, options?: RawAxiosRequestConfig) {
        return CourseStatsApiApiFp(this.configuration).courseStatsApiGetAdminCourseStatsCourses(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.kind, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsForgeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseStatsApiGetAdminCourseStatsForge(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsForgeRequest = {}, options?: RawAxiosRequestConfig) {
        return CourseStatsApiApiFp(this.configuration).courseStatsApiGetAdminCourseStatsForge(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsJobCoursesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseStatsApiGetAdminCourseStatsJobCourses(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsJobCoursesRequest = {}, options?: RawAxiosRequestConfig) {
        return CourseStatsApiApiFp(this.configuration).courseStatsApiGetAdminCourseStatsJobCourses(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsLearnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseStatsApiGetAdminCourseStatsLearner(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsLearnerRequest, options?: RawAxiosRequestConfig) {
        return CourseStatsApiApiFp(this.configuration).courseStatsApiGetAdminCourseStatsLearner(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsLearnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseStatsApiGetAdminCourseStatsLearners(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsLearnersRequest = {}, options?: RawAxiosRequestConfig) {
        return CourseStatsApiApiFp(this.configuration).courseStatsApiGetAdminCourseStatsLearners(requestParameters.activity, requestParameters.endDate, requestParameters.excludeInternal, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.startDate, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Course headline numbers for a window, against the window before it.
     * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseStatsApiGetAdminCourseStatsOverview(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsOverviewRequest = {}, options?: RawAxiosRequestConfig) {
        return CourseStatsApiApiFp(this.configuration).courseStatsApiGetAdminCourseStatsOverview(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsPathsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseStatsApiGetAdminCourseStatsPaths(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsPathsRequest = {}, options?: RawAxiosRequestConfig) {
        return CourseStatsApiApiFp(this.configuration).courseStatsApiGetAdminCourseStatsPaths(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CourseStatsApiApiCourseStatsApiGetAdminCourseStatsTimeseriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseStatsApiGetAdminCourseStatsTimeseries(requestParameters: CourseStatsApiApiCourseStatsApiGetAdminCourseStatsTimeseriesRequest = {}, options?: RawAxiosRequestConfig) {
        return CourseStatsApiApiFp(this.configuration).courseStatsApiGetAdminCourseStatsTimeseries(requestParameters.endDate, requestParameters.excludeInternal, requestParameters.granularity, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }
}

export const CourseStatsApiGetAdminCourseStatsCoursesKindEnum = {
    Catalogue: 'catalogue',
    JobPrep: 'job_prep',
    Forge: 'forge',
    Faculty: 'faculty',
    Unlisted: 'unlisted',
} as const;
export type CourseStatsApiGetAdminCourseStatsCoursesKindEnum = typeof CourseStatsApiGetAdminCourseStatsCoursesKindEnum[keyof typeof CourseStatsApiGetAdminCourseStatsCoursesKindEnum];
export const CourseStatsApiGetAdminCourseStatsCoursesSortByEnum = {
    Learners: 'learners',
    ActiveLearners: 'active_learners',
    Opened: 'opened',
    LessonsStarted: 'lessons_started',
    QuizzesPassed: 'quizzes_passed',
    ReachedLesson2Pct: 'reached_lesson_2_pct',
    CameBackPct: 'came_back_pct',
    AvgLessonsPassed: 'avg_lessons_passed',
    Completed: 'completed',
    Purchases: 'purchases',
    Rating: 'rating',
    LastActivityAt: 'last_activity_at',
    Name: 'name',
} as const;
export type CourseStatsApiGetAdminCourseStatsCoursesSortByEnum = typeof CourseStatsApiGetAdminCourseStatsCoursesSortByEnum[keyof typeof CourseStatsApiGetAdminCourseStatsCoursesSortByEnum];
export const CourseStatsApiGetAdminCourseStatsCoursesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc',
} as const;
export type CourseStatsApiGetAdminCourseStatsCoursesSortOrderEnum = typeof CourseStatsApiGetAdminCourseStatsCoursesSortOrderEnum[keyof typeof CourseStatsApiGetAdminCourseStatsCoursesSortOrderEnum];
export const CourseStatsApiGetAdminCourseStatsLearnersActivityEnum = {
    All: 'all',
    Active: 'active',
    Inactive: 'inactive',
    New: 'new',
    MultiCourse: 'multi_course',
} as const;
export type CourseStatsApiGetAdminCourseStatsLearnersActivityEnum = typeof CourseStatsApiGetAdminCourseStatsLearnersActivityEnum[keyof typeof CourseStatsApiGetAdminCourseStatsLearnersActivityEnum];
export const CourseStatsApiGetAdminCourseStatsLearnersSortByEnum = {
    LastAt: 'last_at',
    FirstAt: 'first_at',
    Courses: 'courses',
    LessonsPassed: 'lessons_passed',
    Name: 'name',
    ActiveCourses: 'active_courses',
    LessonsStarted: 'lessons_started',
    QuizzesPassed: 'quizzes_passed',
    DaysActive: 'days_active',
} as const;
export type CourseStatsApiGetAdminCourseStatsLearnersSortByEnum = typeof CourseStatsApiGetAdminCourseStatsLearnersSortByEnum[keyof typeof CourseStatsApiGetAdminCourseStatsLearnersSortByEnum];
export const CourseStatsApiGetAdminCourseStatsLearnersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc',
} as const;
export type CourseStatsApiGetAdminCourseStatsLearnersSortOrderEnum = typeof CourseStatsApiGetAdminCourseStatsLearnersSortOrderEnum[keyof typeof CourseStatsApiGetAdminCourseStatsLearnersSortOrderEnum];
export const CourseStatsApiGetAdminCourseStatsTimeseriesGranularityEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
} as const;
export type CourseStatsApiGetAdminCourseStatsTimeseriesGranularityEnum = typeof CourseStatsApiGetAdminCourseStatsTimeseriesGranularityEnum[keyof typeof CourseStatsApiGetAdminCourseStatsTimeseriesGranularityEnum];
